import "../common/elements/Header.scss";
import translate from "@/i18n/translate";
export default function UnauthorizedComponent(): JSX.Element {
  return (
    <main className="main-content-home unauth-component">
      <div className="unauthorized-title">
        {translate("app.unauthorized.title")}
      </div>
      <div className="unauth-desc">
        {translate("app.unauthorized.description")}
      </div>
    </main>
  );
}
